
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { FinancialClosing, ApiGateway } from 'cw-backend';
import { SnackBarService } from 'cw-utils';

@Injectable()
export class FinancialClosingEditProvider implements Resolve<any>
{
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    financialClosing: FinancialClosing;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise((resolve, reject) => {
            Promise.all([this.getFinancialClosing()]).then(
                () => {
                    resolve(true);
                },
                reject
            );
        });
    }

    getFinancialClosing(): Promise<any> {
        return new Promise((resolve, reject) => {
            let data =  this.checkLastModifications()
            if (data && data.id == this.routeParams.id) {
                this.financialClosing = data;
                this.onDataChanged.next(this.financialClosing);
                resolve(this.financialClosing);
            } else if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('financialClosing/' + this.routeParams.id).subscribe({next:(res: FinancialClosing ) => {
                    this.financialClosing = res;
                    this.onDataChanged.next(this.financialClosing);
                    resolve(res);
                }, error: (err: any) => { reject(err) }});
            }
        });
    }

    insert(financialClosing): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('financialClosing/', financialClosing).subscribe({next:(response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, error: (err: any) => { reject(err) }});
        });
    }

    edit(financialClosing): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('financialClosing/', financialClosing).subscribe({next:(response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, error: (err: any) => { reject(err) }});
        });
    }

    delete(financialClosing, motive): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('financialClosing/:id', {id: financialClosing.id}, motive).subscribe({next:(response: HttpResponse<any>) => {
                resolve(response);  
                 this.snackBar.successMessage(response.body.message);
            }, error: (err: any) => { reject(err) }});
        });
    }

    checkLastModifications(): FinancialClosing {
        let wasLocked = JSON.parse(localStorage.getItem('session_locked'));
        let data;
        if (wasLocked){
            data = JSON.parse(localStorage.getItem('last_modification'));
            localStorage.removeItem('session_locked');
        }  
        return data;
    }
}
